import { Component, OnInit } from '@angular/core';
import { UserSessionService } from '../../services/user-session-service/user-session.service';
import { Router } from '@angular/router';
import { ShellUpdateService, ShellUpdateMessage, ShellActionMessage } from '../../services/shell-update-service/shell-update.service';
import { AppConfigService } from '../../services/app-config-service/app-config.service';
import { LoggingService } from '../../services/logging-service/logging.service';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { TrustDataService } from '../../services/trust-data-service/trust-data.service';

@Component({
  selector: 'app-portal-admin-cards-view',
  templateUrl: './portal-admin-cards-view.component.html',
  styleUrls: ['./portal-admin-cards-view.component.css']
})
export class PortalAdminCardsViewComponent implements OnInit {

  trustCardSubscription: Subscription;
  homeCards: any;
  aboutMe: any;
  contact: any;
  logout: any;
  myBirthPlan: any;
  myPregnancyAndMe: any;
  myNotes: any;
  loaded: boolean;
  error: boolean;


  aboutMeSaving: boolean;
  myNotesSaving: boolean;
  myBirthPlanSaving: boolean;
  myPregnancyAndMeSaving: boolean;
  contactSaving: boolean;
  logoutSaving: boolean;

  editAboutMe = false;

  constructor(private userSession: UserSessionService, private router: Router,
    private shellUpdateService: ShellUpdateService, private appConfigService: AppConfigService,
    private trustDataService: TrustDataService, private loggingService: LoggingService) { }

  ngOnInit() {

    // Make sure the route being accessed is desirable (not user from admin, or admin from user. Redirect if required)
    this.userSession.checkRoute(this.router.url);
    this.shellUpdateService.sendShellUpdateMessage(new ShellUpdateMessage(this.appConfigService.ApplicationName,
      'Home Card Configuration', null, null));

    this.shellUpdateService.sendShellUpdateActionMessage(new ShellActionMessage(false, false, true, false, true));


    // Get all of the homecard configuration from the service
    this.loggingService.log('Loading card configuration ...', this.appConfigService.LogToConsole);
    this.trustCardSubscription = this.trustDataService.getAllTrustCards()
      .pipe(map(response => response.json()))
      .subscribe(response => {
        this.loggingService.log('Loading cards', this.appConfigService.LogToConsole);
        this.homeCards = response;
        this.aboutMe = this.homeCards.find(x => x.CardName === 'AboutMe');
        this.contact = this.homeCards.find(x => x.CardName === 'Contact');
        this.logout = this.homeCards.find(x => x.CardName === 'Logout');
        this.myBirthPlan = this.homeCards.find(x => x.CardName === 'MyBirthPlan');
        this.myPregnancyAndMe = this.homeCards.find(x => x.CardName === 'MyPregnancyAndMe');
        this.myNotes = this.homeCards.find(x => x.CardName === 'MyNotes');
        this.loaded = true;
        this.loggingService.log('Card configuration loaded successfully', this.appConfigService.LogToConsole);
      });

  }

  updateSpinner(card: any, saving: boolean) {
    switch (card.CardName) {
      case 'AboutMe':
        this.aboutMeSaving = saving;
        break;
      case 'Contact':
        this.contactSaving = saving;
        break;
      case 'Logout':
        this.logoutSaving = saving;
        break;
      case 'MyBirthPlan':
        this.myBirthPlanSaving = saving;
        break;
      case 'MyPregnancyAndMe':
        this.myPregnancyAndMeSaving = saving;
        break;
      case 'MyNotes':
        this.myNotesSaving = saving;
        break;
      default:
        break;
    }
  }


  saveCard(card: any) {
    // Update
    this.updateSpinner(card, true);
    this.loggingService.log(`saveCard(${card.Title}) event triggered`, this.appConfigService.LogToConsole);

    this.trustDataService.updateTrustCard(card)
      .subscribe(response => {
        this.updateSpinner(card, false);
      });
  }

  defaultCard(card: any) {

    // Remove previously set properties so defaults can be used
    card.Title = '';
    card.Description = '';

    // Update
    this.updateSpinner(card, true);
    this.trustDataService.updateTrustCard(card)
      .subscribe(response => {
        this.updateSpinner(card, false);
      });
    this.loggingService.log(`defaultCard(${card.Title}) event triggered`, this.appConfigService.LogToConsole);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/portal-admin-cards-view/portal-admin-cards-view.component.ts